import React, { useCallback } from "react";
import { connect } from "react-redux";

import { EntityType, EntityTypeSupportingGroups, Group } from "@mapmycustomers/shared/types/entity";

import FrequencyPanel from "@app/component/frequency/FrequencyPanel";
import { fetchGroup } from "@app/scene/map/store/actions";
import { fetchGroups } from "@app/store/groups/actions";

interface Props {
  entityType: EntityTypeSupportingGroups;
  fetchGroup: typeof fetchGroup.request;
  fetchGroups: typeof fetchGroups.request;
  group: Group;
}

const Frequency: React.FC<Props> = ({ entityType, fetchGroup, fetchGroups, group }) => {
  const handleUpdate = useCallback(() => {
    fetchGroup({ entityType, groupId: group.id });
    fetchGroups({ entityType });
  }, [entityType, fetchGroups, fetchGroup, group.id]);

  return (
    <FrequencyPanel
      entity={{
        ...group,
        entity:
          entityType === EntityType.COMPANY
            ? EntityType.COMPANY_GROUP
            : entityType === EntityType.PERSON
            ? EntityType.PEOPLE_GROUP
            : EntityType.DEAL_GROUP,
      }}
      isGroup
      onUpdate={handleUpdate}
    />
  );
};

const mapDispatchToProps = {
  fetchGroup: fetchGroup.request,
  fetchGroups: fetchGroups.request,
};

export default connect(null, mapDispatchToProps)(Frequency);
